import { useState, useEffect } from 'react';
import './App.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function App() {
  const [screen, setScreen]           = useState('landing');
  const [email, setEmail]             = useState('');
  const [userId, setUserId] = useState(null);
  const [userName, setUserName]       = useState('');
  const [selectedPOS, setSelectedPOS] = useState(null);
  const [data, setData]               = useState(null);
  const [loading, setLoading]         = useState(false);
  const [activeTab, setActiveTab]     = useState('home');
  const [days, setDays]               = useState(30);
  const [showProfile, setShowProfile]   = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const connected = params.get('connected');
    const uid = params.get('user_id');
    const paid = params.get('paid');

    if (connected === 'true' && uid) {
      setUserId(uid);
      setScreen('payment');
      window.history.replaceState({}, '', '/');
    }
    if (paid === 'true') {
      if (uid) setUserId(uid);
      setScreen('dashboard');
      loadData(30, uid);
      window.history.replaceState({}, '', '/');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePOSSelect = (pos) => {
    setSelectedPOS(pos);
    setScreen('connect');
  };

  const handleConnect = () => {
     if (selectedPOS === 'square') {
      window.location.href = `${API}/auth/square`;
    } else if (selectedPOS === 'clover') {
      window.location.href = `${API}/auth/clover`;
    } else {
      setScreen('coming-soon');
    }
  };

  const loadData = (daysParam, uid) => {
    const currentUserId = uid || userId;
    setLoading(true);
    const url = currentUserId
      ? `${API}/store/${currentUserId}/dashboard`
      : `${API}/demo/analytics?days=${daysParam}`;
    fetch(url)
      .then(res => res.json())
      .then(json => {
        setData(json);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const handleDemoMode = () => {
    setLoading(true);
    fetch(`${API}/demo/analytics?days=30`)
      .then(res => res.json())
      .then(json => {
        setData(json);
        setLoading(false);
        setScreen('dashboard');
      })
      .catch(() => {
        setLoading(false);
        alert('Could not connect to backend. Make sure your server is running.');
      });
  };

  const handleFilterChange = (newDays) => {
    loadData(newDays);
  };

  if (loading) return <Loader />;

 switch (screen) {
        case 'landing':     return <Landing onStart={() => setScreen('email')} />;
        case 'email':       return <EmailScreen onNext={(email, name) => { setEmail(email); setUserName(name); setScreen('select-pos'); }} onBack={() => setScreen('landing')} />;
        case 'select-pos':  return <SelectPOS onSelect={handlePOSSelect} onBack={() => setScreen('email')} />;
        case 'connect':     return <Connect pos={selectedPOS} onConnect={handleConnect} onDemo={handleDemoMode} onBack={() => setScreen('select-pos')} />;
        case 'coming-soon': return <ComingSoon pos={selectedPOS} onBack={() => setScreen('select-pos')} />;
        case 'payment':     return <PaymentScreen userId={userId} onSuccess={() => { setScreen('dashboard'); loadData(30); }} />;
        case 'dashboard':   return showProfile
          ? <Profile userName={userName} email={email} pos={selectedPOS} onBack={() => setShowProfile(false)} onLogout={() => { setScreen('landing'); setData(null); setShowProfile(false); }} />
          : <Dashboard data={data} userName={userName} activeTab={activeTab} setActiveTab={setActiveTab} days={days} setDays={setDays} onFilterChange={handleFilterChange} onProfile={() => setShowProfile(true)} />;
        default:            return <Landing onStart={() => setScreen('email')} />;
      }

// ── Landing Page ───────────────────────────────────────────
function Landing({ onStart }) {
  return (
    <div className="screen landing-screen">
      <div className="landing-top">
        <div className="logo">shelf<span>ie</span></div>
  
      </div>
      <div className="landing-hero">
        <h1>Your store's money,<br /><em>finally visible</em></h1>
        <p>Connect your POS in 10 minutes. Get a plain-English report every Monday showing exactly where you're making and losing money.</p>
      </div>
      <div className="landing-features">
        <div className="feature-row">
          <div className="feature-icon green">$</div>
          <div>
            <div className="feature-title">See what's actually making you money</div>
            <div className="feature-sub">Ranked by real profit, not just sales volume</div>
          </div>
        </div>
        <div className="feature-row">
          <div className="feature-icon red">!</div>
          <div>
            <div className="feature-title">Catch dead stock before it costs you</div>
            <div className="feature-sub">Know what to discount before it expires</div>
          </div>
        </div>
        <div className="feature-row">
          <div className="feature-icon green">↑</div>
          <div>
            <div className="feature-title">Staff smarter, not harder</div>
            <div className="feature-sub">Match your rota to when customers actually show up</div>
          </div>
        </div>
      </div>
      <div className="landing-pos-row">
        <div className="pos-badge">Square</div>
        <div className="pos-badge">Shopify</div>
        <div className="pos-badge">Clover</div>
        <div className="pos-badge">Lightspeed</div>
      </div>
      <button className="btn-primary" onClick={onStart}>Get started — it's free</button>
      <p className="landing-fine">14-day money back guarantee. Cancel anytime.</p>
    </div>
  );
}

// ── Email Screen ───────────────────────────────────────────
function EmailScreen({ onNext, onBack }) {
  const [localEmail, setLocalEmail] = useState('');
  const [localName, setLocalName] = useState('');

  const handleNext = () => {
    if (!localEmail.includes('@') || !localName) return;
    onNext(localEmail, localName);
  };

  return (
    <div className="screen form-screen">
      <div className="form-header">
        <button className="back-btn" onClick={onBack}>← Back</button>
        <div className="logo">shelf<span>ie</span></div>
        <div className="step-indicator">Step 1 of 3</div>
      </div>
      <div className="form-body">
        <h2>Let's get started</h2>
        <p>Enter your details to create your free Shelfie account.</p>
        <div className="form-group">
          <label>Your name</label>
          <input
            type="text"
            placeholder="e.g. Raj Patel"
            value={localName}
            onChange={e => setLocalName(e.target.value)}
            autoComplete="name"
          />
        </div>
        <div className="form-group">
          <label>Your email</label>
          <input
            type="email"
            placeholder="you@youremail.com"
            value={localEmail}
            onChange={e => setLocalEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleNext()}
            autoComplete="email"
          />
        </div>
        <button
          className="btn-primary"
          onClick={handleNext}
          disabled={!localEmail.includes('@') || !localName}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

// ── Select POS ─────────────────────────────────────────────
function SelectPOS({ onSelect, onBack }) {
  const options = [
    { id: 'square',     label: 'Square',     desc: 'Most common for independent stores', available: true },
    { id: 'shopify',    label: 'Shopify',    desc: 'For stores selling online + in-person', available: false },
    { id: 'clover', label: 'Clover', desc: 'Popular in NJ independent retail', available: true },
    { id: 'lightspeed', label: 'Lightspeed', desc: 'Best for inventory-heavy stores', available: false },
  ];

  return (
    <div className="screen form-screen">
      <div className="form-header">
        <button className="back-btn" onClick={onBack}>← Back</button>
        <div className="logo">shelf<span>ie</span></div>
        <div className="step-indicator">Step 2 of 3</div>
      </div>
      <div className="form-body">
        <h2>Which POS do you use?</h2>
        <p>Shelfie connects directly to your existing system — no data entry needed.</p>
        <div className="pos-list">
          {options.map(pos => (
            <button
              key={pos.id}
              className={`pos-option ${!pos.available ? 'coming-soon-option' : ''}`}
              onClick={() => onSelect(pos.id)}
            >
              <div className="pos-option-left">
                <div className="pos-option-name">{pos.label}</div>
                <div className="pos-option-desc">{pos.desc}</div>
              </div>
              <div className="pos-option-right">
                {pos.available
                  ? <div className="pos-available">Connect →</div>
                  : <div className="pos-soon">Coming soon</div>
                }
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── Connect Screen ─────────────────────────────────────────
function Connect({ pos, onConnect, onDemo, onBack }) {
  const posNames = { square: 'Square', shopify: 'Shopify', clover: 'Clover', lightspeed: 'Lightspeed' };
  return (
    <div className="screen form-screen">
      <div className="form-header">
        <button className="back-btn" onClick={onBack}>← Back</button>
        <div className="logo">shelf<span>ie</span></div>
        <div className="step-indicator">Step 3 of 3</div>
      </div>
      <div className="form-body">
        <h2>Connect your {posNames[pos]} account</h2>
        <p>You'll be taken to {posNames[pos]}'s login page. Sign in and click Allow — that's it. Shelfie never sees your password.</p>
        <div className="connect-steps">
          <div className="connect-step">
            <div className="connect-step-num">1</div>
            <div>Click the button below</div>
          </div>
          <div className="connect-step">
            <div className="connect-step-num">2</div>
            <div>Log into your {posNames[pos]} account</div>
          </div>
          <div className="connect-step">
            <div className="connect-step-num">3</div>
            <div>Click Allow — you're done</div>
          </div>
        </div>
        <button className="btn-primary" onClick={onConnect}>
          Connect {posNames[pos]} →
        </button>
        <button className="btn-secondary" onClick={onDemo}>
          Try demo with sample data
        </button>
      </div>
    </div>
  );
}

// ── Coming Soon Screen ─────────────────────────────────────
function ComingSoon({ pos, onBack, onDemo }) {
  const posNames = { shopify: 'Shopify', clover: 'Clover', lightspeed: 'Lightspeed' };
  return (
    <div className="screen form-screen">
      <div className="form-header">
        <button className="back-btn" onClick={onBack}>← Back</button>
        <div className="logo">shelf<span>ie</span></div>
      </div>
      <div className="form-body" style={{textAlign: 'center'}}>
        <div style={{fontSize: '48px', marginBottom: '1rem'}}>🔧</div>
        <h2>{posNames[pos]} coming soon</h2>
        <p style={{marginBottom: '2rem'}}>{posNames[pos]} integration is in progress. We'll email you the moment it's ready.</p>
        <button className="btn-primary" onClick={onDemo}>Try demo with sample data</button>
        <button className="btn-secondary" onClick={onBack}>Choose a different POS</button>
      </div>
    </div>
  );
}

// ── Profile Screen ─────────────────────────────────────────
function Profile({ userName, email, pos, onBack, onLogout }) {
  const posNames = { square: 'Square', shopify: 'Shopify', clover: 'Clover', lightspeed: 'Lightspeed' };
  const initials = userName ? userName.split(' ').map(n => n[0]).join('').toUpperCase() : '?';

  return (
    <div className="screen form-screen">
      <div className="form-header">
        <button className="back-btn" onClick={onBack}>← Back</button>
        <div className="logo">shelf<span>ie</span></div>
        <div></div>
      </div>
      <div className="form-body">
        <div className="profile-avatar">{initials}</div>
        <h2 style={{textAlign:'center', marginBottom:'4px'}}>{userName || 'Store Owner'}</h2>
        <p style={{textAlign:'center', color:'var(--gray-400)', marginBottom:'2rem'}}>{email}</p>

        <div className="profile-section-label">Account</div>
        <div className="profile-card">
          <div className="profile-row">
            <div className="profile-row-label">Name</div>
            <div className="profile-row-value">{userName}</div>
          </div>
          <div className="profile-row">
            <div className="profile-row-label">Email</div>
            <div className="profile-row-value">{email}</div>
          </div>
        </div>

        <div className="profile-section-label">Connected POS</div>
        <div className="profile-card">
          <div className="profile-row">
            <div className="profile-row-label">{pos ? posNames[pos] : 'None'}</div>
            <div className="profile-row-value green">✓ Connected</div>
          </div>
        </div>

        <div className="profile-section-label">Subscription</div>
        <div className="profile-card">
          <div className="profile-row">
            <div className="profile-row-label">Plan</div>
            <div className="profile-row-value">Shelfie Pro — $79/month</div>
          </div>
          <div className="profile-row">
            <div className="profile-row-label">Status</div>
            <div className="profile-row-value green">Active</div>
          </div>
        </div>

        <button className="btn-secondary" style={{marginTop:'2rem', color:'var(--red)', borderColor:'var(--red)'}} onClick={onLogout}>
          Log out
        </button>
      </div>
    </div>
  );
}

// ── Loader ─────────────────────────────────────────────────
function Loader() {
  return (
    <div className="loader-screen">
      <div className="loader-logo">shelf<span>ie</span></div>
      <div className="loader-spinner"></div>
      <p>Analysing your store...</p>
    </div>
  );
}

// — Payment Screen ————————————————————————————
function PaymentScreen({ userId, onSuccess }) {
  const [loading, setLoading] = useState(false);

  const handlePayment = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/payments/create-checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId }),
      });
      const data = await res.json();
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      }
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <div className="screen form-screen">
      <div className="form-header">
        <div className="logo">shelf<span>ie</span></div>
      </div>
      <div className="form-body">
        <div className="payment-icon">🎉</div>
        <h2>Your store is connected!</h2>
        <p>Start your Shelfie subscription to unlock your dashboard.</p>
        <div className="payment-card">
          <div className="payment-plan">Shelfie Pro</div>
          <div className="payment-price">$79<span>/month</span></div>
          <ul className="payment-features">
            <li>✓ Weekly AI insights</li>
            <li>✓ Product profit rankings</li>
            <li>✓ Staff hour optimization</li>
            <li>✓ Dead stock alerts</li>
            <li>✓ Cancel anytime</li>
          </ul>
        </div>
        <button className="btn-primary" onClick={handlePayment} disabled={loading}>
          {loading ? 'Redirecting to payment...' : 'Start for $79/month →'}
        </button>
        <p className="landing-fine">14-day money back guarantee. No questions asked.</p>
      </div>
    </div>
  );
}
// ── Dashboard ──────────────────────────────────────────────
function Dashboard({ data, userName, activeTab, setActiveTab, days, setDays, onFilterChange, onProfile }) {
  if (!data) return <Loader />;
  return (
    <div className="app">
      <Header userName={userName} onProfile={onProfile} />
      <TimeFilter days={days} setDays={setDays} onFilterChange={onFilterChange} />
      <div className="content">
        {activeTab === 'home'     && <Home data={data} />}
        {activeTab === 'products' && <Products data={data.profit_lens} />}
        {activeTab === 'staff'    && <Staff data={data.labour_score} />}
        {activeTab === 'alerts'   && <Alerts data={data.anomaly_alerts} />}
      </div>
      <BottomNav activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
}
function TimeFilter({ days, setDays, onFilterChange }) {
  const options = [
    { label: '7 days',  value: 7  },
    { label: '30 days', value: 30 },
    { label: '90 days', value: 90 },
  ];
  return (
    <div className="time-filter">
      {options.map(opt => (
        <button
          key={opt.value}
          className={`filter-btn ${days === opt.value ? 'active' : ''}`}
          onClick={() => { setDays(opt.value); onFilterChange(opt.value); }}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
function Header({ userName, onProfile }) {
  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
  return (
    <div className="header">
      <div>
        <p className="header-greeting">{greeting}{userName ? `, ${userName.split(' ')[0]}` : ''}</p>
        <h2 className="header-title">Here's your store report</h2>
      </div>
      <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
        <div className="header-logo">shelf<span>ie</span></div>
        <button className="profile-btn" onClick={onProfile}>
          {userName ? userName.charAt(0).toUpperCase() : '?'}
        </button>
      </div>
    </div>
  );
}
}

function Home({ data }) {
  const profit  = data.profit_lens;
  const waste   = data.waste_detector;
  const labour  = data.labour_score;
  const anomaly = data.anomaly_alerts;
  const topInsight = profit.insights?.[0] || anomaly.alerts?.[0];

  return (
    <div className="tab-content">
      {topInsight && (
        <div className="insight-banner">
          <div className="insight-label">This week's top insight</div>
          <div className="insight-text">{topInsight}</div>
        </div>
      )}
      <div className="metrics-grid">
        <MetricCard label="Total revenue" value={`$${profit.total_revenue?.toLocaleString()}`} sub={`${profit.products_analyzed} products`} subColor="green" />
        <MetricCard label="Dead stock" value={waste.slow_mover_count} sub={waste.slow_mover_count === 0 ? 'All clear' : 'items stagnant'} subColor={waste.slow_mover_count === 0 ? 'green' : 'red'} />
        <MetricCard label="Peak hour" value={labour.peak_hour ? labour.peak_hour.label.split(' ')[0] : 'N/A'} sub={labour.peak_hour ? `$${labour.peak_hour.revenue}` : ''} subColor="green" />
        <MetricCard label="Basket size" value={`$${anomaly.this_week?.avg_basket}`} sub={`${anomaly.changes?.basket_pct > 0 ? '+' : ''}${anomaly.changes?.basket_pct}% vs avg`} subColor={anomaly.changes?.basket_pct >= 0 ? 'green' : 'red'} />
      </div>
      <div className="section-label">Top products</div>
      {profit.ranked_products?.slice(0, 4).map((p, i) => (
        <ProductRow key={i} product={p} max={profit.ranked_products[0].total_revenue} />
      ))}
      <div className="section-label" style={{marginTop:'1.5rem'}}>Weekly alerts</div>
      {anomaly.alerts?.map((alert, i) => (
          <div key={i} className="alert-row">{alert}</div>
        ))}

        {data.ai_insights?.length > 0 && (
          <>
            <div className="section-label" style={{marginTop: '1.5rem'}}>🤖 AI recommendations</div>
            {data.ai_insights.map((insight, i) => (
              <div key={i} className="ai-insight-row">
                <span className="ai-insight-number">{i + 1}</span>
                <span>{insight}</span>
              </div>
            ))}
          </>
        )}
      </div>
  );
}

function MetricCard({ label, value, sub, subColor }) {
  return (
    <div className="metric-card">
      <div className="metric-label">{label}</div>
      <div className="metric-value">{value}</div>
      <div className={`metric-sub ${subColor}`}>{sub}</div>
    </div>
  );
}

function ProductRow({ product, max }) {
  const pct = max > 0 ? (product.total_revenue / max) * 100 : 0;
  return (
    <div className="product-row">
      <div className="product-info">
        <div className="product-name">{product.name}</div>
        <div className="product-bar-wrap">
          <div className="product-bar" style={{width:`${pct}%`}}></div>
        </div>
      </div>
      <div className="product-revenue">${product.total_revenue?.toLocaleString()}</div>
    </div>
  );
}

function Products({ data }) {
  return (
    <div className="tab-content">
      <div className="page-title">
        <h2>Product performance</h2>
        <p>Ranked by total revenue</p>
      </div>
      {data.insights?.map((insight, i) => (
        <div key={i} className="insight-banner" style={{marginBottom:'8px'}}>{insight}</div>
      ))}
      <div className="section-label" style={{marginTop:'1rem'}}>All products</div>
      {data.ranked_products?.map((p, i) => (
        <div key={i} className="product-card">
          <div className="product-card-rank">#{i + 1}</div>
          <div className="product-card-info">
            <div className="product-card-name">{p.name}</div>
            <div className="product-card-stats">
              <span>{p.total_quantity} units sold</span>
              <span>{p.revenue_share}% of revenue</span>
            </div>
          </div>
          <div className="product-card-revenue">${p.total_revenue?.toLocaleString()}</div>
        </div>
      ))}
    </div>
  );
}

function Staff({ data }) {
  const active = data.hourly_breakdown?.filter(h => h.revenue > 0);
  return (
    <div className="tab-content">
      <div className="page-title">
        <h2>Staff efficiency</h2>
        <p>Sales by hour of day</p>
      </div>
      {data.insights?.map((insight, i) => (
        <div key={i} className="insight-banner" style={{marginBottom:'8px'}}>{insight}</div>
      ))}
      <div className="section-label" style={{marginTop:'1rem'}}>Hourly breakdown</div>
      {active?.map((h, i) => (
        <div key={i} className="hour-row">
          <div className="hour-label">{h.label}</div>
          <div className="hour-orders">{h.orders} orders</div>
          <div className="hour-revenue">${h.revenue}</div>
        </div>
      ))}
      {active?.length === 0 && <div className="empty-state">No hourly data yet</div>}
    </div>
  );
}

function Alerts({ data }) {
  return (
    <div className="tab-content">
      <div className="page-title">
        <h2>Weekly alerts</h2>
        <p>Compared to your 4-week average</p>
      </div>
      <div className="stats-row">
        <div className="stat-box">
          <div className="stat-label">This week</div>
          <div className="stat-value">${data.this_week?.revenue?.toLocaleString()}</div>
          <div className="stat-sub">{data.this_week?.orders} orders</div>
        </div>
        <div className="stat-box">
          <div className="stat-label">4-week avg</div>
          <div className="stat-value">${data.four_week_average?.revenue?.toLocaleString()}</div>
          <div className="stat-sub">{data.four_week_average?.orders} orders/wk</div>
        </div>
      </div>
      <div className="section-label" style={{marginTop:'1.5rem'}}>Alerts</div>
      {data.alerts?.map((alert, i) => (
        <div key={i} className="alert-row">{alert}</div>
      ))}
    </div>
  );
}

function BottomNav({ activeTab, setActiveTab }) {
  const tabs = [
    { id: 'home',     label: 'Home',     icon: '⊞' },
    { id: 'products', label: 'Products', icon: '◫' },
    { id: 'staff',    label: 'Staff',    icon: '◉' },
    { id: 'alerts',   label: 'Alerts',   icon: '◎' },
  ];
  return (
    <div className="bottom-nav">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`nav-btn ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => setActiveTab(tab.id)}
        >
          <span className="nav-icon">{tab.icon}</span>
          <span className="nav-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
}


export default App;
